import { render, staticRenderFns } from "./PaginationPanelDay.vue?vue&type=template&id=b0a4cf60&scoped=true"
import script from "./PaginationPanelDay.vue?vue&type=script&lang=ts"
export * from "./PaginationPanelDay.vue?vue&type=script&lang=ts"
import style0 from "./PaginationPanelDay.vue?vue&type=style&index=0&id=b0a4cf60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a4cf60",
  null
  
)

export default component.exports